/* Entrada de secciones al hacer scroll.
 *
 * Marca los bloques con `.fp-revela` y les saca la clase cuando entran en
 * pantalla. Se hace desde JS y no desde el Liquid a propósito: si el navegador
 * no ejecuta esto, el contenido nunca se esconde y la página se ve entera.
 *
 * No toca el hero: es lo primero que se ve y esconderlo para revelarlo se
 * siente lento, no moderno.
 */
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto || !('IntersectionObserver' in window)) return;

  var SELECTORES = [
    '.fp-marcas__titulo',
    '.fp-categorias__titulo',
    '.fp-categorias__grid > *',
    '.fp-logos__texto',
    '.fp-logos__grid',
    '.fp-valores__intro',
    '.fp-valor',
    '.fp-galeria__titulo',
    '.fp-contacto__col',
    '.fp-bloque__texto',
    '.fp-bloque__media',
    /* Los tres puntos de «Llegamos a todo el país»: el diseñador los quiere
       entrando uno por uno, no los tres de golpe. */
    '.fp-bloque .fp-puntos li',
    /* El listado y la ficha quedaron fuera a propósito: ahí animaba un solo
       título suelto en toda la página y el resto no, que es justamente la
       mezcla que el cliente objetó. El catálogo va quieto entero. */
  ];

  var nodos = [];
  SELECTORES.forEach(function (sel) {
    [].slice.call(document.querySelectorAll(sel)).forEach(function (el) {
      if (nodos.indexOf(el) === -1) nodos.push(el);
    });
  });
  if (!nodos.length) return;

  function revelar(el, rescate) {
    if (rescate) el.classList.add('is-rescatado');
    el.classList.add('is-visible');
    observador.unobserve(el);
    el.addEventListener('transitionend', function () {
      el.classList.add('is-listo');
    }, { once: true });
  }

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) return revelar(e.target, false);
      /* Si quedó ARRIBA del viewport sin haber entrado nunca, no va a haber
         otro callback y se quedaría escondido para siempre. Pasaba de verdad:
         con un salto al pie (tecla Fin, volver con el botón atrás, un flick de
         trackpad o un ancla /#contacto) quedaban 11 de 13 bloques del home en
         opacidad 0, y sólo reaparecían si volvías a subir pasándoles por
         encima. De ahí la sensación de que la página «se va acomodando». */
      if (e.boundingClientRect.bottom < 0) revelar(e.target, true);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  /* Red de seguridad: pase lo que pase, al segundo y medio no queda nada
     escondido. Cubre los casos que el observador no llega a ver. */
  window.setTimeout(function () {
    nodos.forEach(function (el) {
      if (!el.classList.contains('is-visible')) revelar(el, true);
    });
  }, 1500);

  nodos.forEach(function (el) {
    /* Lo que ya está en pantalla al cargar no se esconde: si no, se ve un
       parpadeo en todo lo que está arriba del pliegue. */
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.9) return;

    el.classList.add('fp-revela');
    /* Escalonado por posición entre hermanos que también se revelan, no por
       índice global: así los tres puntos de «Llegamos a todo el país» entran
       1-2-3 aunque en la lista general estén salteados.

       Bajó de 90 ms con tope 5 (450 ms) a 50 con tope 3 (150 ms). Con el
       anterior, dentro de una misma fila de tres tarjetas la última entraba
       180 ms después que la primera y se leía como cascada. */
    var antes = 0;
    var hermano = el.previousElementSibling;
    while (hermano && hermano.classList.contains('fp-revela')) {
      antes++;
      hermano = hermano.previousElementSibling;
    }
    if (antes) el.style.transitionDelay = Math.min(antes, 3) * 50 + 'ms';
    observador.observe(el);
  });
})();

/* Carrusel de fotos del home: el mouse manda la velocidad.
 *
 * Sobre el cuarto izquierdo la tira corre para atrás y más rápido, sobre el
 * cuarto derecho para adelante y más rápido, y en el medio se frena para poder
 * mirar la foto.
 *
 * Se toca `playbackRate` de la animación CSS, nunca `play()`/`pause()`: el
 * arnés de medición congela todo con `animation-play-state: paused !important`
 * y llamar a `play()` desde la API le arrebataría el control a esa regla. Con
 * playbackRate el congelado sigue funcionando y `npm run verificar` mide igual.
 */
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto) return;

  var ZONA = 0.25; // cuánto de cada costado dispara la aceleración
  var RAPIDO = 3;  // veces la velocidad normal
  var FRENO = 0;   // en el medio queda quieta

  function preparar(marco) {
    var pista = marco.querySelector('.fp-galeria__pista');
    if (!pista || !pista.getAnimations) return;

    function correr(rate) {
      var animaciones = pista.getAnimations();
      for (var i = 0; i < animaciones.length; i++) {
        var a = animaciones[i];
        /* updatePlaybackRate cambia la velocidad sin saltar de posición.
           Safari viejo no lo tiene: ahí el cambio es seco pero no se rompe. */
        if (a.updatePlaybackRate) a.updatePlaybackRate(rate);
        else a.playbackRate = rate;
      }
    }

    marco.addEventListener('mousemove', function (e) {
      var caja = marco.getBoundingClientRect();
      if (!caja.width) return;
      var x = (e.clientX - caja.left) / caja.width;
      var zona = x < ZONA ? 'izq' : x > 1 - ZONA ? 'der' : 'medio';
      if (marco.dataset.fpZona === zona) return;
      marco.dataset.fpZona = zona;
      correr(zona === 'izq' ? -RAPIDO : zona === 'der' ? RAPIDO : FRENO);
    });

    marco.addEventListener('mouseleave', function () {
      delete marco.dataset.fpZona;
      correr(1);
    });
  }

  [].slice.call(document.querySelectorAll('.fp-galeria__marco')).forEach(preparar);
})();

/* Video en las tarjetas de categoría.
 *
 * Pedido del cliente: «En estas placas, se pueden poner videos? para que cuando
 * le pases por arriba se muevan». Sí se puede, y esto es lo que lo hace andar.
 *
 * El video se carga con `preload="none"`: seis videos precargando en el home
 * pesarían más que toda la página junta. Recién al pasar por arriba se pide el
 * archivo y se reproduce, y se muestra cuando ya hay imagen, así no aparece un
 * rectángulo negro mientras baja.
 *
 * Sólo con puntero fino: en un teléfono no hay «pasar por arriba», y un video
 * que arranca solo al tocar la tarjeta antes de navegar es ruido y datos.
 */
(function () {
  var videos = [].slice.call(document.querySelectorAll('[data-fp-cat-video]'));
  if (!videos.length) return;

  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var puntero = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (quieto || !puntero) return;

  videos.forEach(function (video) {
    var tarjeta = video.closest('.fp-cat');
    if (!tarjeta) return;

    /* `playing` y no `play()`: entre que se pide y hay imagen pasan cientos de
       milisegundos, y encender la opacidad antes deja ver el negro del <video>. */
    video.addEventListener('playing', function () {
      video.classList.add('is-andando');
    });

    tarjeta.addEventListener('mouseenter', function () {
      /* La promesa se rechaza si el navegador bloquea el autoplay o si el mouse
         se fue antes de que arrancara. No es un error: se ignora y queda la foto. */
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });

    tarjeta.addEventListener('mouseleave', function () {
      video.classList.remove('is-andando');
      /* Vuelve al primer cuadro para que el próximo hover no retome a la mitad.
         La pausa va después del fundido para que no se congele a la vista. */
      window.setTimeout(function () {
        if (video.classList.contains('is-andando')) return;
        video.pause();
        video.currentTime = 0;
      }, 350);
    });
  });
})();

/* Galería infinita también cuando el sistema pide menos movimiento.
 *
 * Normalmente la tira corre sola y no se puede arrastrar: el marco recorta y la
 * pista no scrollea, así que el loop del CSS no tiene fin visible.
 *
 * Con «Reducir movimiento» activado —muy común en iPhone— `fp-ritmo.css` apaga
 * la animación y deja el marco con `overflow-x: auto`, o sea una tira que se
 * arrastra a mano. Esa sí termina: llegás al final de las dos copias y se
 * acaba. Es lo que el cliente reportó como «que el slider sea infinito».
 *
 * No corresponde devolverle el movimiento automático a quien pidió lo
 * contrario. Lo que se hace es cerrar el círculo: como el contenido está
 * duplicado, saltar exactamente el ancho de una copia cae sobre la misma foto y
 * no se nota. El scroll queda siempre en la copia del medio y nunca toca un
 * borde.
 */
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!quieto) return;

  var marco = document.querySelector('.fp-galeria__marco');
  var pista = marco && marco.querySelector('.fp-galeria__pista');
  if (!pista || pista.children.length < 4) return;

  var items = [].slice.call(pista.children);
  var mitad = items.length / 2;
  /* El ancho de una copia se mide entre dos ítems equivalentes, no dividiendo
     `scrollWidth`: la pista lleva padding lateral y eso rompería la
     periodicidad justo lo suficiente para que el salto se vea. */
  var copia = items[mitad].offsetLeft - items[0].offsetLeft;
  if (!copia) return;

  marco.scrollLeft = copia / 2;

  var ajustando = false;
  marco.addEventListener('scroll', function () {
    if (ajustando) return;
    var x = marco.scrollLeft;
    var nuevo = x;
    if (x > copia) nuevo = x - copia;
    else if (x < 1) nuevo = x + copia;
    if (nuevo === x) return;
    /* La bandera evita que el propio ajuste vuelva a entrar acá. Se levanta en
       el frame siguiente, cuando el navegador ya emitió su evento de scroll. */
    ajustando = true;
    marco.scrollLeft = nuevo;
    requestAnimationFrame(function () { ajustando = false; });
  }, { passive: true });
})();
